import React from 'react' ;
import { scaleTime } from 'd3-scale' ;
import {timeHour, timeDay} from 'd3-time' ;
//import {timeFormat} from 'd3-time-format' ;
import {MetricsService} from './../../../services/metrics.service' ;
import { Tooltip, ResponsiveContainer, XAxis, YAxis, CartesianGrid, Area,  AreaChart, Legend, Label } from 'recharts';
import moment from 'moment' ;

// const labelColor =  {
//     'publicIncoming': '#8467bf',
//     'privateIncoming': '#a965ba',
//     'publicOutgoing': '#864ba3',
//     'privateOutgoing': '#a34b8a',
//     'CPU Usage': '#516abd',
//     'read': '#82ba54',
//     'write': '#b2ba54',

// } ;

// const tooltipBgColor = {
//     'bandwidth' : '#e9e4f2',
//     'cpu' : '#d5dae8',
//     'diskio' : '#e1e8da',
// } ;

class MetricsAreaChart extends React.Component{

    constructor(props){
        super(props)
        this.state = {
            data:  [],
            originalData:[],
            isLoaded: false,
            format:1,
            yLabels: []
        }
    }
  
    componentDidMount() {
        this.getDataByType(1);
    }

    // getColorBasedOnLabel(labelType){        
    //     let color = {
    //         'Public In': '#3779d4',
    //         'Private In': '#5594ea',
    //         'Public Out': '#7aa9e9',
    //         'Private Out': '#9bc1f4',
    //         'CPU %': '#cdb2f2',
    //         'read': '#8fd9e6',
    //         'write': '#5bc7da',

    //     } ;       
    //     return color[labelType] ;
    // }

    getFillColor(labelType){        
        let color = {
            'Public In': '#e0f0fc',
            'Private In': '#b5dcf9',
            'Public Out': '#96c6ea',
            'Private Out': '#7ab4df',
            'CPU %': '#c9f2e5',
            'read': '#fff0f0',
            'write': '#ffdddd',

        } ;       
        return color[labelType] ;
    }
    getStrokeColor(labelType){        
        let color = {
            'Public In': '#84bde8',
            'Private In': '#6ca7d3',
            'Public Out': '#6ca7d3',
            'Private Out': '#5692bf',
            'CPU %': '#82c7b1',
            'read': '#f2a6a6',
            'write': '#e49393',

        } ;       
        return color[labelType] ;
    }

    // tooltipBgColor(type){
    //     let bgColor = {
    //         'bandwidth' : '#3779d4',
    //         'cpu' : '#af84e9',
    //         'diskio' : '#5bc7da',
    //     } ;

    //     return bgColor[type] ;
    // }

    // getGradientIdBasedOnLabel(labelType){
    //     let gradientIds = {
    //         "Public In": "url(#publicInColor)",
    //         "Private In": "url(#publicOutColor)",
    //         "Public Out": "url(#privateInColor)",
    //         "Private Out": "url(#privateOutColor)",
    //         "CPU %": "url(#cpuColor)",
    //         "read": "url(#readColor)",
    //         "write": "url(#writeColor)"
    //     };
    //     return gradientIds[labelType] ;
    // }

    formatDate(d, format = "tooltip") {
        if(format == "tooltip"){
            return moment(d).format('MMM DD, YY hh:mm A') ;
        }
        else if(format == "1" ){
           
            return moment(d).format('HH:mm') ;
        }
        else if(format == "7" || format == "30" ){
            return moment(d).format('MMM DD, YY') ;
        }
        
    }

    getCustomTicks(domainStartDate, domainEndDate){
        let duration = this.state.format ;
        let customTicks 
        if(duration === 1){
            customTicks = scaleTime().domain([domainStartDate,timeHour.floor(domainEndDate)]).ticks(timeHour, 1) ;
        }
        if(duration === 7){
            customTicks = scaleTime().domain([domainStartDate,timeDay.floor(domainEndDate)]).ticks(timeDay, 1) ;
        }
        //const formatTime = timeFormat("%I:%M %p"); 
        //console.log(customTicks) ;
        return customTicks ;
    }

    getDataByType(timePeriod) {
        let startDate = new Date()
        let timeLagMinutes = 0 ;
        let revisedStartDate = new Date(startDate.getTime() - timeLagMinutes*60*1000) ;
        //let endDate = revisedStartDate ;
        let endDate = new Date(startDate.getTime() - timeLagMinutes*60*1000) ;
        revisedStartDate = new Date(revisedStartDate.setDate(revisedStartDate.getDate() - timePeriod)) ; 
        let startDateUTC = this.getStartDateinUtc(revisedStartDate); 
        MetricsService.getDataByType(this.props.type, this.props.instanceId,startDateUTC,this.props.regionName).then(resp => {
            if(resp.length>0){
                let newResp = resp ;
                let respKeys = Object.keys(resp[0]) ;
                respKeys.shift() ;
                //console.log(resp)
                newResp = this.filterDataByTimePeriod(newResp, revisedStartDate, endDate);
                //console.log(newResp)
                newResp = this.fillMissingDataWithZeros(newResp, revisedStartDate, endDate, respKeys) ;
                // console.log(revisedStartDate)
                // console.log(endDate)
                //console.log(newResp)
                // if(resp.length===1){
                //     newResp = this.dummyDataforGraph(resp);
                // }
                this.setState({data:resp,originalData:newResp,format:timePeriod, yLabels: respKeys});
            }
            this.setState({isLoaded:true});
            //console.log(resp)
        }).catch(error => {
            console.log("Error occured"+ error) ;
        });
    }

    getStartDateinUtc(now){
        let startUtc = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(),  now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds());
        return startUtc.getTime()
    }


    filterDataByTimePeriod(data, now, endDate) {
        let filtData ;
        filtData = data.filter(function(item){
            let date =  item["Date"];
            return date >=now  && date <= endDate;
        });
        return filtData;                 
    }

    // evaluateMetrics(data){       
    //     let keys = this.state.yLabels ;
    //     let lenData = data.length ;
    //     let metrics = {} ;
    //     keys.forEach((key) => {
    //         metrics[key] = {'sum': 0,'max': -9999} ;
    //     });
    //     for (let obj of data) {
    //         keys.forEach((key) => {
    //             let val = obj[key] ; 
    //             if( val  > metrics[key]['max']){
    //                 metrics[key]['max'] = val ;
    //             }
    //             metrics[key]['sum']+= val  ;     
    //     });
    //     }
    //     keys.forEach((key) => {
    //         metrics[key]['avg'] = parseFloat(((metrics[key]['sum'])/lenData).toFixed(2))  ;
    //         metrics[key]['last'] = data[lenData-1][key]
    //     });
    //     return metrics
    // }

    fillMissingDataWithZeros(data, startDate, endDate, keys){
        let dataStartDate = data[0]["Date"] ;
        let dataEndDate = data[data.length-1]["Date"] ;
        let numberOfZerosAtStart = Math.ceil((dataStartDate.getTime() - startDate.getTime())/(5*60*1000)) ;
        //let numberOfZerosAtEnd = Math.ceil((endDate.getTime() - dataEndDate.getTime())/(5*60*1000)) ;  
        let keysLength = keys.length ;
        //let tempZeroStartData = [] ;

        //fill zeros in between
        for(let i = 1; i< data.length; i++){
            let timeDiff = (data[i]["Date"]).getTime() - (data[i-1]["Date"]).getTime() ;
            if(timeDiff > 5*60*1000){
                // console.log(data[i]["Date"])
                // console.log(data[i-1]["Date"])
                let NumberOfDataPoints = Math.ceil(timeDiff/(5*60*1000)) ;
                let ZeroDataArray = [] ;
                for(let j=0; j< NumberOfDataPoints; j++){
                    let obj = {} ;
                    obj.Date = new Date((data[i-1]["Date"]).getTime() + (j+1)*5*60*1000) ;
                    //console.log(obj.Date)
                    for(let j=0; j<keysLength; j++){
                        obj[keys[j]] = data[i][keys[j]]/NumberOfDataPoints ;
                    }
                    // if(data[i] && (Object.entries(data[i]).length)){
                    //     data.splice(i, 0, obj);
                    // }
                    // else{
                    //     data.push(obj) ;
                    // }
                    
                    ZeroDataArray.push(obj) ;
                }
                //console.log(ZeroDataArray)
                if(ZeroDataArray.length){
                  data =  data.slice(0, i).concat(ZeroDataArray, data.slice(i+1, data.length)) ;
                  //console.log(data) ;
                  i= i+ZeroDataArray.length-1 ;
                }
            }
        }

        //fill zeros at start
        if((startDate < dataStartDate) && (numberOfZerosAtStart > 0)){
            for(let i=0; i<numberOfZerosAtStart; i++){
                let obj = {} ;
                obj.Date = new Date(dataStartDate.getTime() - (i+1)*5*60*1000) ;
                for(let j=0; j<keysLength; j++){
                    obj[keys[j]] = 0 ;
                }
                data.unshift(obj) ;
                //tempZeroStartData.push(obj) ;
            }
            //data = tempZeroStartData.concat(data) ;
        }
        
        //fill zeros at end
        // if((endDate > dataEndDate) && (numberOfZerosAtEnd > 0)){
        //     for(let i=0; i<numberOfZerosAtEnd-1; i++){
        //         let obj = {} ;
        //         obj.Date = new Date(dataEndDate.getTime() + (i+1)*5*60*1000) ;
        //         for(let j=0; j<keysLength; j++){
        //             obj[keys[j]] = 0 ;
        //         }
        //         data.push(obj) ;
        //     }
        // }
        return data ;
    }
    

    render(){
        if(!this.state.isLoaded){
            return(<div class="graph_loader_ctnr">
                  <div class="graph_loader"></div>
                    </div>);
        }
        // console.log( this.props.type) ;
        // console.log( this.state.isLoaded) ;
        // console.log( this.state.data) ;
        // console.log( this.state.data.length) ;
        if (this.state.isLoaded && this.state.data.length === 0) {
            let iconClass = "";
            let emptyMessg = "";
            if (this.props.type === 'bandwidth') {
                iconClass = "public_bdw";
                emptyMessg = "No summary for Bandwidth.";
            } else if (this.props.type === 'cpu') {
                iconClass = "usageCpu";
                emptyMessg = "No data for CPU usage";
            } else {
                iconClass = "disk_io";
                emptyMessg = "No Disk I/O";
            }
            return (<div className="outer_empty_wrap">
                <div className="inner_empty_wrap">
                    <div className={"svg_wrap empty_icon summary_empty " + iconClass}></div>
                    <p className="empty_title"> {emptyMessg} </p>
                </div>
            </div>);
        }

        let type = this.props.type;

        const CustomTooltip = ({ active, payload, label }) => {
            if (active && payload && payload.length) {
              return (
                <div className="custom-tooltip" style={{"padding": "5px"}}>
                  <p className="tooltip_date" style={{"color": "#778899", "fontWeight": "bold", textAlign: "center"}}>{`${this.formatDate(label)}`}</p>
                  {
                    this.state.yLabels.map((yLabel, index) =>   
                    //console.log(label)                 
                    <ul className="chart_tooltip" key={index}>
                        <li>
                            <span className="tooltip_legend" key={`${index + 'legend'}`} style={{"background": `${this.getFillColor(yLabel)}`}}> </span>
                            <span className="tooltip_label" key={`${index + 'label'}`} style={{"color": "#000000", "fontWeight": "bold"}}> {`${yLabel} : `} </span>
                            <span className="tooltip_value" key={`${index + 'value'}`} style={{"color": "#708090", "fontWeight": "bold"}}>{`${ (type==='bandwidth' || type==='diskio') ? ' ' + formatBytes(payload[index].value, type, 2) : ' ' + (payload[index].value).toFixed(2)+ " %"  }`}<br/></span>  
                            {/* <span> {`${this.getFillColor(yLabel)}`} </span>                   */}
                        </li>
                    </ul>
                  )}
                </div>
              );
            }
          
            return null;
        };

        const renderLegend = (props) => {
            const { payload } = props;    
            //console.log(payload) ;
            let data = this.state.originalData ; 
            let keys = this.state.yLabels ;
            let lenData = data.length ;
            let metrics = {} ;
            keys.forEach((key) => {
                metrics[key] = {'sum': 0,'max': -9999} ;
            });
            for (let obj of data) {
                keys.forEach((key) => {
                    let val = obj[key] ; 
                    if( val  > metrics[key]['max']){
                        metrics[key]['max'] = val ;
                    }
                    metrics[key]['sum']+= val  ;     
            });
            }
            keys.forEach((key) => {
                if(type==='bandwidth' || type==='diskio'){
                    metrics[key]['max'] = formatBytes((metrics[key]['max']), type, 2)  ;
                    metrics[key]['avg'] = formatBytes(((metrics[key]['sum'])/lenData), type, 2)  ;
                   // metrics[key]['last'] = formatBytes((data[lenData-1][key]), type, 2) ;
                }
                else{
                    metrics[key]['max'] = parseFloat((metrics[key]['max']).toFixed(2)) + ' %' ;
                    metrics[key]['avg'] = parseFloat(((metrics[key]['sum'])/lenData).toFixed(2)) + ' %';
                   // metrics[key]['last'] = parseFloat((data[lenData-1][key]).toFixed(2)) + '%';
                }
            });
            //console.log(metrics)            
            return (
                
                <ul className="chart-values">

                    <li className="chartVal_header">
                        <div className="chart_col chart_col1">&nbsp;</div>
                        <div className="chart_col chart_col2">Max</div>
                        <div className="chart_col chart_col3">Avg</div>
                    </li>
                    {    
                            payload.map((entry, index) => (
                                
                                <li key={index}>
                                <div className="chart_col chart_col1">
                                <i style={{"background": `${entry.payload.fill}`}}></i><span>{entry.value}</span>
                                </div>
                                <div className="chart_col chart_col2">
                                <span>{metrics[entry.value]['max']}</span>
                                </div>
                                <div className="chart_col chart_col3">
                                <span>{metrics[entry.value]['avg']}</span>
                                </div>
                                {/* <div> {`${entry.payload.fill}`} </div> */}
                            </li>
                        ))
                    }
              </ul>
            );
          }

          const domainStartDate = this.state.originalData[0]["Date"] ;
          const domainEndDate = this.state.originalData[this.state.originalData.length-1]["Date"] ;
        //   console.log(domainStartDate)
        //   console.log(domainEndDate)
        
        return(
            <div className = "area_chart " style={{"width": "100%", "height": "300px"}}>
                <ResponsiveContainer width="100%" height="100%">
                    <AreaChart  data={this.state.originalData}
                        margin={{ top: 10, right: 20, left: 5, bottom: 0 }} >                    
                    {/* <defs >
                        <linearGradient id="publicInColor" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#8467bf" stopOpacity={0.8}/>
                            <stop offset="95%" stopColor="#8467bf" stopOpacity={0}/>
                        </linearGradient>
                        <linearGradient id="publicOutColor" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#a965ba" stopOpacity={0.8}/>
                            <stop offset="95%" stopColor="#a965ba" stopOpacity={0}/>
                        </linearGradient>
                        <linearGradient id="privateInColor" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#864ba3"stopOpacity={0.8}/>
                            <stop offset="95%" stopColor="#864ba3" stopOpacity={0}/>
                        </linearGradient>
                        <linearGradient id="privateOutColor" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#a34b8a" stopOpacity={0.8}/>
                            <stop offset="95%" stopColor="#a34b8a" stopOpacity={0}/>
                        </linearGradient>
                        <linearGradient id="cpuColor" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="20%" stopColor="#5eabf3" stopOpacity={0.8}/>
                            <stop offset="40%" stopColor="#5eabf3" stopOpacity={0.6}/>
                            <stop offset="60%" stopColor="#5eabf3" stopOpacity={0.4}/>
                            <stop offset="80%" stopColor="#5eabf3" stopOpacity={0.2}/>
                            <stop offset="95%" stopColor="#5eabf3" stopOpacity={0}/>
                        </linearGradient>
                        <linearGradient id="readColor" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#82ba54" stopOpacity={0.8}/>
                            <stop offset="95%" stopColor="#82ba54" stopOpacity={0}/>
                        </linearGradient>
                        <linearGradient id="writeColor" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#b2ba54" stopOpacity={0.8}/>
                            <stop offset="95%" stopColor="#b2ba54" stopOpacity={0}/>
                        </linearGradient>
                        
                    </defs>                    */}
                    <XAxis dataKey="Date"  scale="time"  ticks={this.getCustomTicks(domainStartDate, domainEndDate)} domain={[domainStartDate, domainEndDate]} tickFormatter={ (Date) =>  `${this.formatDate(Date, this.state.format)}`} >
                    </XAxis >
                    {/* <XAxis dataKey="Date" interval="preserveEnd" tickFormatter={ (Date) =>  `${this.formatDate(Date, this.state.format)}`}  minTickGap = {this.state.format===1 ? 35: 29} tickLine = {true}>
                    </XAxis > */}
                    <YAxis width={70} interval="preserveStartEnd" allowDuplicatedCategory="false" tickFormatter = { (Number) =>  `${(type==='bandwidth' || type==='diskio') ? formatBytes(Number, type, 0): parseFloat(Number.toFixed(1)) + " %"}`} >
                    </YAxis >
                    <CartesianGrid strokeDasharray="3 3" horizontal='true' vertical='true' />
                    {/* <Tooltip content = {<CustomTooltip/>} wrapperStyle={{backgroundColor: this.tooltipBgColor(type)}}/> */}
                    <Tooltip content = {<CustomTooltip/>}  wrapperStyle={{backgroundColor: 'white', borderStyle: 'solid', borderWidth:'thin', borderColor: '#A9A9A9', borderRadius:'5px'}} cursor={{ stroke: 'black', strokeWidth: 1}} />
                    <Legend layout="horizontal" verticalAlign="top" align="center" chartWidth="100%" chartHeight={100} content={renderLegend}/>
                    { this.state.yLabels.map((label, index) => 
                    // <React.Fragment>
                    // <defs >
                    //     <linearGradient id={index} x1="0" y1="0" x2="0" y2="1">
                    //     <stop offset="25%" stopColor={this.getColorBasedOnLabel(label)} stopOpacity={0.8}/>
                    //     <stop offset="45%" stopColor={this.getColorBasedOnLabel(label)} stopOpacity={0.6}/>
                    //     <stop offset="65%" stopColor={this.getColorBasedOnLabel(label)} stopOpacity={0.4}/>
                    //     <stop offset="85%" stopColor={this.getColorBasedOnLabel(label)} stopOpacity={0.2}/>
                    //     </linearGradient>
                        
                    // </defs>
                    <Area  name= {label}  key={index} type="monotone" dataKey={label} stroke={this.getStrokeColor(label)} fillOpacity={1} fill={this.getFillColor(label)} activeDot={{ fill: this.getStrokeColor(label), stroke: this.getStrokeColor(type), strokeWidth: 2, r:4  }}/>
                    // </React.Fragment>
                    )}                       
                    </AreaChart>
                </ResponsiveContainer>
            </div>
        )

        
    }
}

function bytesConversionPerSecond(bytes, type, flag='tooltip'){
    
    if(flag === 'tooltip'){
        if(type === 'bandwidth'){
            let bitsPerSecond = (bytes*8)/(5*60) ;
            if (bitsPerSecond> -1024 && bitsPerSecond < 1024 ) return parseFloat(bitsPerSecond.toFixed(2)) + ' b/s' ; 
            return parseFloat((bitsPerSecond/1024).toFixed(2)) + ' Kb/s';
        }
        if (bytes> -1024 && bytes < 1024 ) return parseFloat((bytes/(5*60)).toFixed(2)) + ' B/s' ; 
        return parseFloat(((bytes)/(5*60*1024)).toFixed(2)) + ' KB/s';
    }
    if(flag === 'label'){
        if(type === 'bandwidth'){
            let bitsPerSecond = (bytes*8)/(5*60) ;
            if (bitsPerSecond> -1024 && bitsPerSecond < 1024 ) return parseFloat(Math.round(bitsPerSecond)) + ' b/s' ; 
            return Math.round(bitsPerSecond/1024) + ' Kb/s';
        }
        if (bytes> -1024 && bytes < 1024 ) return parseFloat(Math.round(bytes/(5*60))) + ' B/s' ; 
        return Math.round((bytes)/(5*60*1024)) + ' KB/s';
    }
}

function formatBytes(bytes, type, decimals = 2) {
    let bitsOrBytesPerSecond = (type === 'bandwidth') ? (bytes*8)/(5*60) : bytes/(5*60);
    if (bitsOrBytesPerSecond === 0) return (type === 'bandwidth') ? '0 b/s' : '0 B/s';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = (type === 'bandwidth') ? ['b/s', 'Kb/s', 'Mb/s', 'Gb/s', 'Tb/s', 'Pb/s', 'Eb/s', 'Zb/s', 'Yb/s'] : ['B/s', 'KB/s', 'MB/s', 'GB/s', 'TB/s', 'PB/s', 'EB/s', 'ZB/s', 'YB/s'];
    let i = Math.floor(Math.log(bitsOrBytesPerSecond) / Math.log(k));
    if(i < 0) {
        i = 0 ;
    }
    //if(flag === 0) return sizes[i] ;
    const dataSize =  parseFloat((bitsOrBytesPerSecond / Math.pow(k, i)).toFixed(dm)) ;
    //if(flag === 1 || dataSize === 0 ) return dataSize ; 
    return dataSize + ' ' + sizes[i] ;
}


// function SampleGraphData () {

//     let sample_data_x = Array.from({'length': 10}, (value,index) => index+1)
//     let sample_data_y = Array.from({length:10}, () => 1 + Math.floor(Math.random()*10)) ;
//     let sample_data_z = Array.from({length:10}, () => 3 + Math.floor(Math.random()*10)) ;

//     let sample_json_data = [
//         {
//             x : sample_data_x[0], 
//             y : sample_data_y[0],
//             z : sample_data_z[0]
//         },
//         {
//             x : sample_data_x[1], 
//             y : sample_data_y[1],
//             z : sample_data_z[1]
//         },
//         {
//             x : sample_data_x[2], 
//             y : sample_data_y[2],
//             z : sample_data_z[2]
//         },
//         {
//             x : sample_data_x[3], 
//             y : sample_data_y[3],
//             z : sample_data_z[3]
//         },
//         {
//             x : sample_data_x[4], 
//             y : sample_data_y[4],
//             z : sample_data_z[4]
//         },
//         {
//             x : sample_data_x[5], 
//             y : sample_data_y[5],
//             z : sample_data_z[5]
//         },
//         {
//             x : sample_data_x[6], 
//             y : sample_data_y[6],
//             z : sample_data_z[6]
//         },
//         {
//             x : sample_data_x[7], 
//             y : sample_data_y[7],
//             z : sample_data_z[7]
//         },
//         {
//             x : sample_data_x[8], 
//             y : sample_data_y[8],
//             z : sample_data_z[8]
//         },
//         {
//             x : sample_data_x[9], 
//             y : sample_data_y[9],
//             z : sample_data_z[9]
//         }
//     ] 
//     // console.log(sample_data_x);
//     // console.log(sample_data_y);
//     // console.log(sample_json_z);
//     console.log(sample_json_data)
//     return sample_json_data ;
// };

// function generateRandomColor(){
//     return '#'+(0x1000000+Math.random()*0xffffff).toString(16).substr(1,6) ;
// }

export default MetricsAreaChart ;
